import React, { useState, useEffect } from 'react';

import classes from './TVCardImage.module.css';

export default function TVCardImage({ postData, isShorts, isShortCard, className }) {
  const { image_field: { images }, aspect_ratio } = postData;
  const [imageAspectRatio, setImageAspectRatio] = useState(aspect_ratio);

  useEffect(() => {
    /**
     * this adds an exception for older images that were uploaded using the
     * previous landscape aspect ration even for potrait ones.
     * 
     * Here we gave them a static 1.25 aspect ratio 
     * which will make the potrait once app fully potrait and add a space in the landscape ones
     */
    if (Number(aspect_ratio).toFixed(2) === "0.67") {
      setImageAspectRatio(1.25);
    } else {
      setImageAspectRatio(aspect_ratio);
    }
  }, [aspect_ratio]);
  return (<div className={`${isShorts ? `${classes.short}` : ''} ${isShortCard ? `${classes.shortCard}` : ''} ${classes.mainDiv} ${className}`} >
    <img
      draggable="false"
      src={images[0]}
      alt="PlaceholderImg"
      style={{
        aspectRatio: isShorts ? isShortCard ? '11/16' : 'unset' : `${1 / imageAspectRatio}`
      }}
    />
  </div>);
}
